import {useParams} from 'react-router-dom';
import Text from '@frontend/ui-kit/Components/Text';
import ContentSection from '@frontend/ui-kit/Components/ContentSection';
import BaseLayout from '../../../Components/shared/BaseLayout';
import ErrorContent from '../../../Components/Error/ErrorContent';
import {gettext} from '../../../translationService';

const ServerError = () => {
    const {errorCode = ''} = useParams();

    return (
        <BaseLayout>
            <ContentSection>
                <ErrorContent errorCode={errorCode} title={gettext('Internal Server Error')}>
                    <Text>
                        {gettext('Sorry, something went wrong on our end!')}
                    </Text>
                </ErrorContent>
            </ContentSection>
        </BaseLayout>
    );
};

export {ServerError as TestableServerError};
export default ServerError;
